import { PageRequestModel, PaginationResponseModel, ProjectModel, UserModel } from '@/models';
import {
  DifficultyLevelTaskModel,
  GetByIdRequestModel,
  GetByIdResponseModel,
  GetOrderedTaskListTaskItemModel,
  GetProjectTasksRequestModel,
  GetTaskListByTreeShortRequestModel,
  GetTaskListByTreeShortResponseItemModel,
  GetTaskListByTreeShortResponseModel,
  GetTaskListRequestFilterModel,
  OrderTaskModel,
  ProjectGetBuIdRequestModel,
  SortingSettingsTaskModel,
  TaskParameterModel,
  TaskPersonModel,
  TaskQueueModel,
} from '../models';
import { TaskModel } from '../models/TaskModel';
import { BaseProjectResponseModel } from '../models/BaseProjectResponseModel';

export const mapGetTasksByProjectIdRequest = (request: GetProjectTasksRequestModel) =>
  new GetTaskListByTreeShortRequestModel({
    ProjectId: request.ProjectId,
    CurrentUserId: request.CurrentUserId,
    Filter: new GetTaskListRequestFilterModel({
      Search: request.Filter.Search,
      PerformerIds: request.Filter.Performers,
      WithoutPriorities: null,
      WithoutTags: null,
    }),
    DateStart: request.DateStart,
    DateEnd: request.DateEnd,
    IsFilterTimerByPerformerIds: request.IsFilterTimerByPerformerIds,

    Page: request.Page
      ? new PageRequestModel({
          Take: request.Page.Take,
          Skip: request.Page.Skip,
        })
      : undefined,
    SortingSettings: new SortingSettingsTaskModel({
      OrderDescendingByName: request.Sort.OrderByName,
      OrderDescendingByTaskId: request.Sort.OrderById,
      OrderDescendingByEstimates: request.Sort.OrderByEstimateTime,
      OrderDescendingBySpent: request.Sort.OrderByWorkTime,
    }),
  });

export const mapGetEmployeeRequest = (employeeId: number) =>
  new GetByIdRequestModel({
    UserId: employeeId,
  });

export const mapGetTasksByProjectIdResponse = (
  response: GetTaskListByTreeShortResponseModel | GetTaskListByTreeShortResponseModel,
) =>
  new PaginationResponseModel<Array<OrderTaskModel>>({
    Current: response.Page.Current,
    Count: response.Page.Count,
    Size: response.Page.Size,
    TotalWorkTime: response.TotalWorkTime,
    IsSuccess: true,
    Items: response.Items.map(
      (item) =>
        new OrderTaskModel({
          ...mapTaskModel(item, item.ProjectId, true),
          HasAccessToTask: item.HasAccessToTask,
          ChangeAccess: item.CanSetUpInOrderTask,
        }),
    ),
  });

export const mapGetEmployeeResponse = (response: GetByIdResponseModel) =>
  new UserModel({
    Id: response.UserId,
    FirstName: response.FirstName,
    LastName: response.LastName,
    MiddleName: response.MiddleName,
    ImageUrl: response.Foto,
    AvatarColor: response.AvatarColor,
  });

/**Получение модели задачи */
export const mapTaskModel = (
  item: GetTaskListByTreeShortResponseItemModel | GetOrderedTaskListTaskItemModel,
  projectId?: number,
  isTreeShortResponse?: boolean,
) => {
  const task = new TaskModel({
    Id: item.Id,

    ProjectId: projectId,
    EstimateTime: item.EstimateTime,
    WorkTime: item.WorkTime,
    Name: item.Name,
    Difficulty: new DifficultyLevelTaskModel({
      DifficultyId: item?.Difficulty?.DifficultyId,
      DifficultyColor: item?.Difficulty?.DifficultyColor,
      DifficultyName: item?.Difficulty?.DifficultyName,
    }),

    Status: new TaskParameterModel({
      Id: item.Status?.StatusId,
      Name: item.Status?.StatusName,
      Color: item.Status?.StatusColor,
    }),
    Priority: new TaskParameterModel({
      Id: item.Priority?.PriorityId,
      Name: item.Priority?.PriorityName,
      Color: item.Priority?.PriorityColor,
    }),
  });

  if (isTreeShortResponse) {
    item = item as GetTaskListByTreeShortResponseItemModel;
    Object.assign(task, {
      ProjectId: item.ProjectId || projectId,
      Project: new ProjectModel({
        Id: item.ProjectId || projectId,
        Name: item.ProjectName,
        ImageUrl: item.ProjectImage,
        PreviewColor: item.ProjectPreviewColor,
      }),
      Queues: item.QueueTaskList.map(
        (queue) =>
          new TaskQueueModel({
            Id: queue.Id,
            Name: queue.Name,
            NamespaceId: queue.Namespace.Id,
          }),
      ),
      NamespaceInfo: item.QueueTaskList.map((queue) => queue.Namespace),
      Performers: item.Performers?.map(
        (performer) =>
          new TaskPersonModel({
            Id: performer.Id,
            FirstName: performer.FirstName,
            LastName: performer.LastName,
            MiddleName: performer.MiddleName,
            ImageUrl: performer.Photo,
            NoPhotoColor: performer.AvatarColor,
          }),
      ),
      Author: new TaskPersonModel({
        Id: item.Owner.Id,
        FirstName: item.Owner.FirstName,
        LastName: item.Owner.LastName,
        MiddleName: item.Owner.MiddleName,
        ImageUrl: item.Owner.Photo,
        NoPhotoColor: item.Owner.AvatarColor,
      }),
    });
  }
  return task;
};

export const mapGetProjectRequest = (projectId: number) =>
  new ProjectGetBuIdRequestModel({
    ProjectId: projectId,
  });

export const mapGetProjectResponse = (response: BaseProjectResponseModel) =>
  new ProjectModel({
    Id: response.Id,
    Name: response.Name,
    ImageUrl: response.ImageUrl,
    PreviewColor: response.PreviewColor,
    WeekEnable: response.WeeekEnable,
    Admins: response.Admins.map(
      (x) =>
        new UserModel({
          Id: x.UserId,
          FirstName: x.FirstName,
          MiddleName: x.MiddleName,
          LastName: x.LastName,
          ImageUrl: x.Foto,
          AvatarColor: x.AvatarColor,
        }),
    ),
  });
